// @flow
import React, { Component, Fragment } from 'react';
import SearchBox from 'components/search/SearchBox';
import { SearchActions } from 'store/actionCreators';
import { type State } from 'store';
import { connect } from 'react-redux';
import { type ContextRouter, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

type Props = {
  currentKeyword: ?string,
  currentMenu: ?string,
} & ContextRouter;

class SearchBoxContainer extends Component<Props> {
  onSearch = (keyword: string, menu: string, facets?: Object, sort?: string) => {
    const { currentKeyword, currentMenu, history } = this.props;

    // 새로고침 시에는 URL 변경하지 않고 검색만 실행
    // const currentQuery = new URLSearchParams(history.location.search);
    // const isRefresh = currentQuery.get('q') === keyword &&
    //                  currentQuery.get('menu') === menu &&
    //                  JSON.stringify(facets || {}) === (currentQuery.get('facets') || '{}') &&
    //                  (sort || 'views:desc') === (currentQuery.get('sort') || 'views:desc');

    // if (isRefresh) {
    //   return SearchActions.publicSearch({
    //     q: keyword,
    //     menu,
    //     facets: facets ? JSON.stringify(facets) : '{}',
    //     sort: sort || 'views:desc',
    //   });
    // }

    if (currentKeyword === keyword && currentMenu === menu) return null;
    if (!keyword) {
      // SearchActions.initialize();
      return null;
    }
    // SearchActions.initialize();
    const q = keyword.replace(/&/g, '%26').replace(/\+/g, '%2B');

    // URL 쿼리 파라미터 구성
    const queryParams = new URLSearchParams();
    queryParams.set('q', q);
    queryParams.set('menu', menu || 'products');

    if (facets && Object.keys(facets).length > 0) {
      queryParams.set('facets', JSON.stringify(facets));
    }

    if (sort && sort !== 'views:desc') {
      queryParams.set('sort', sort);
    }

    history.push(`/search?${queryParams.toString()}`);

    return SearchActions.publicSearch({
      q,
      menu,
      facets: facets ? JSON.stringify(facets) : '{}',
      sort: sort || 'views:desc',
    });
  };

  render() {
    const { currentKeyword, currentMenu } = this.props;
    const title = currentKeyword ? `${currentKeyword} | 캐시바이 검색` : '캐시바이 검색';
    return (
      <Fragment>
        <Helmet>
          <title>{title}</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <SearchBox onSearch={this.onSearch} currentMenu={currentMenu} />
      </Fragment>
    );
  }
}

export default connect((state: State) => ({
  currentKeyword: state.search.currentKeyword,
  currentMenu: state.search.currentMenu,
}))(withRouter(SearchBoxContainer));



// WEBPACK FOOTER //
// ./src/containers/search/SearchBoxContainer.js